import RequestModule from '@/assets/libs/requestModule'
import Util, { mapPlanoToConsumerType } from '@/assets/libs/util'
import router from '@/router'
import store from '@/store'
import md5 from 'md5'

const doLogin = async function (email, password, rememberPassword, showNotification = true) {
  if (email === '' || password === '') {
    Util.showErrorNotification('Todos os campos são obrigatórios')
    return false
  }

  const storedUser = Util.getLocalVar('storedUser')

  const newPassword = md5(`odhen${password}7833`)

  // se o usuario tiver marcado para lembrar a senha, ele vai usar o refresh token
  // se não, ele vai usar a senha nova
  const data = {
    email,
    password: password === '%use@stored@pass%' && storedUser?.refreshToken && rememberPassword ? storedUser?.refreshToken : newPassword
  }

  try {
    const response = await RequestModule.postRequest('consumer/login', data)
    showNotification && Util.showSuccessNotification('Login efetuado com sucesso')

    // set token
    Util.setLocalVar('SESSION_TOKEN', response.data.token)

    const user = response.data
    user.rememberPassword = rememberPassword
    user.email = email

    // se o usuario tiver marcado para lembrar a senha, seta o refresh token
    // e se a senha for diferente de %use@stored@pass% (senha padrão)
    user.refreshToken = rememberPassword && password !== '%use@stored@pass%' ? newPassword : storedUser?.refreshToken

    // Faz o mapeamento com base no idplano
    const originalConsumerType = user.consumerType
    const planoResponse = await mapPlanoToConsumerType(user, email)
    if (planoResponse.error) {
      Util.showErrorNotification(planoResponse.message)
    } else {
      const requestData = {
        clientCode: user.clientCode,
        consumerCode: user.consumerCode,
        consumerType: planoResponse.consumerType
      }

      if (originalConsumerType !== user.consumerType) {
        await RequestModule.postRequest('/consumer/update-consumer-type', requestData)
      } else {
        console.log('Tipo de consumidor permanece o mesmo:', user.consumerType)
        user.consumerType = 'T' // Mesmo que o tipo seja o mesmo, garantimos que seja atualizado para 'T'
      }
    }

    store.commit('setUser', user)
    // console.log(response)

    return true
  } catch (error) {
    const message = error?.response?.data?.message || 'Erro ao validar seu acesso. Tente novamente.'
    showNotification && Util.showErrorNotification(message)
    return false
  }
}

const doLogout = function () {
  Util.removeLocalVar('SESSION_TOKEN')

  const storedUser = Util.getLocalVar('storedUser')
  if (storedUser) {
    Util.removeLocalVar('storedUser')
    store.commit('setUser', null)
  }
  router.push('/login')
}

const forgotPassword = async function (email) {
  // envia requisicao para enviar email
  const data = {
    email
  }

  try {
    const response = await RequestModule.postRequest('consumer/reset-password-email', data)
    return response
  } catch (error) {
    console.log(error)
    const message = error?.response?.data?.message || 'Erro ao enviar email'
    return {
      error: true,
      message
    }
  }
}

const updatePasswordAfterRecover = async function (token, password) {
  const newPassword = md5(`odhen${password}7833`)
  const data = {
    password: newPassword
  }

  try {
    const response = await RequestModule.postRequest('consumer/reset-password', data, token)
    return response
  } catch (error) {
    console.log(error)
    const message = error?.response?.data?.message || 'Erro ao atualizar senha'
    return {
      error: true,
      message
    }
  }
}

const doOtpLogin = async function (email, showNotification = true) {
  if (email === '') {
    Util.showErrorNotification('O campo de e-mail é obrigatório')
    return false
  }

  const data = {
    email,
    basic: true
  }

  try {
    const response = await RequestModule.postRequest('consumer/login', data)

    // set token
    Util.setLocalVar('SESSION_TOKEN', response.data.token)

    const user = response.data
    user.email = email
    user.rememberPassword = false // Nesse caso, sem remember, pois é via OTP

    store.commit('setUser', user)

    return {
      error: false,
      message: 'Login efetuado com sucesso'
    }
  } catch (error) {
    const message = error.response?.data?.message || 'Erro ao validar seu acesso. Tente novamente.'
    showNotification && Util.showErrorNotification(message)
    return {
      error: true,
      message
    }
  }
}

const refreshUserStatus = async function () {
  const user = store.getters.getUser
  if (!user || !user.email) {
    return false
  }

  try {
    const tempUser = { ...user }
    const planoResponse = await mapPlanoToConsumerType(tempUser, user.email)

    if (planoResponse.error) {
      Util.showErrorNotification(planoResponse.message)
      return user.consumerType !== 'T' // se deu erro, user.consumerType será T
    }

    if (tempUser.consumerType !== user.consumerType) {
      console.warn('Tipo de consumidor alterado:', user.consumerType, '->', tempUser.consumerType)
      store.commit('setUser', tempUser)
      return true
    }

    return false
  } catch (error) {
    console.error('Erro ao atualizar status do usuário:', error)
    Util.showErrorNotification('Erro ao atualizar status do usuário')
    return false
  }
}

const checkUserByEmail = async (email) => {
  const data = {
    email
  }

  try {
    await RequestModule.postRequest('consumer/get-by-email', data)
    return { exists: true }
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message && error.response.data.message.includes('não encontrado')) {
      return { exists: false }
    }
    console.error('Erro ao verificar o e-mail:', error)
    return { error: true, message: 'Não foi possível verificar seu e-mail. Tente novamente.' }
  }
}

export { checkUserByEmail, doLogin, doLogout, doOtpLogin, forgotPassword, refreshUserStatus, updatePasswordAfterRecover }
